/**
 * @author Munnaf Hossain Mondal <munnaf.hossain@redappletech.com>
 * @version 1.2.1
 * create date : Friday 9 May 2023 12∶18∶31 PM
 * last Update : Friday 26 Jun 2023 04∶18∶31 PM
 * Note:  Main file to control 3D Room
 * Last Update By : Munnaf Hossain Mondal
 */

/******************* URL FOR STORE VIEW IN LOCAL *****************/
/*
for shoe room
http://localhost:8082/?s_slug=yuniceyeglasses&page=1

# Run the local server at localhost:8080
npm run dev

# Build for production in the dist/ directory
npm run build

just extract the Zip and run. If getting any error the run- npm install

/************************************************************ */

import './style.css'
import * as THREE from 'three'
import { IndoorControls } from './three_utils/IndoorControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { MathUtils, Vector3 } from 'three'
import { EquirectangularReflectionMapping } from 'three/build/three.module'
import Helpers from './Helpers'
import Service from './Service'

let camera, scene, renderer, controls;
let viewport;
let mouseHelper = new THREE.Object3D();
let httpService = new Service();
let noOfRoom = 0;
let current_room = 1
const objectsInScene = [];

$('#PreviousButton').hide();
$('#NextButton').hide();


let apibaseUrl = "https://api.ralbatech.com/api/v1/";//New structure
// let apibaseUrl = "http://localhost:5000/api/v1/";//New structure

const baseUrl = "https://ralbatech.com";
// const baseUrl = "http://localhost:4200/";

// Security Service for API calls
class SecurityService {
    constructor() {
        // These should match your environment variables
        this.encKey = "WmS81fl8F6v3ghnN7VzbrTKbd85H7n4uFwhcFj89j0M="; // Base64 encoded 32-byte key
        this.iv = "hMhzs+WOGF1xZwV+L1COeg=="; // Base64 encoded 16-byte IV
        this.clientId = "ralbatech";
        this.isProd = true; // Set to true for production
        // this.secureUrl = "http://localhost:5000/sec/v1/"; // Local secure URL for signing
        this.secureUrl = "https://api.ralbatech.com/sec/v1/"; // Local secure URL for signing
        
        // Domains for which signing/encryption must be bypassed (third-party)
        this.bypassHosts = [
            'paypal.com',
            'api-m.paypal.com',
            'sandbox.paypal.com'
        ];
    }

    getKey() {
        return CryptoJS.enc.Base64.parse(this.encKey);
    }

    getIV() {
        return CryptoJS.enc.Base64.parse(this.iv);
    }

    encrypt(data) {
        const json = JSON.stringify(data);
        const encrypted = CryptoJS.AES.encrypt(json, this.getKey(), {
            iv: this.getIV(),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString(); // Base64-encoded ciphertext
    }

    decrypt(encryptedBase64) {
        const decrypted = CryptoJS.AES.decrypt(encryptedBase64, this.getKey(), {
            iv: this.getIV(),
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
        try {
            return JSON.parse(decryptedText);
        } catch (e) {
            throw new Error("Failed to decrypt the text");
        }
    }

    getUrlPath(url) {
        const urlArr = url.split("/");
        const v1Index = urlArr.findIndex(str => str === "v1");
        if (v1Index === -1) return url;
        else return "/api/" + urlArr.slice(v1Index).join("/");
    }

    getHostname(url) {
        try {
            const u = new URL(url);
            return u.hostname;
        } catch {
            return null;
        }
    }

    isThirdPartyUrl(url) {
        const host = this.getHostname(url);
        if (!host) return false; // relative => first-party
        const h = host.toLowerCase();
        return this.bypassHosts.some(bh => h === bh || h.endsWith(`.${bh}`));
    }

    async signedRequest(method, url, body = null, clientId = this.clientId) {
        // If not production OR third-party URL, skip signing and encryption entirely
        if (!this.isProd || this.isThirdPartyUrl(url)) {
            const token = localStorage.getItem('user_token');
            const headers = {
                'Content-Type': 'application/json',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            };

            const options = {
                method: method,
                headers: headers
            };

            if (body && method !== 'GET') {
                options.body = JSON.stringify(body);
            }

            const response = await fetch(url, options);
            
            // Handle authentication errors
            if (response.status === 401) {
                throw new Error('Missing authentication headers');
            }
            
            return await response.json();
        }

        // Production flow with signing - works for localhost:5000
        console.log('🔐 Starting signed request flow for:', url);
        const isFormData = body instanceof FormData;
        const encryptedBodyStr = body && !isFormData ? this.encrypt(body) : null;

        const payload = {
            clientId,
            method,
            path: this.getUrlPath(url),
            bodyStr: encryptedBodyStr,
        };

        console.log('📦 Payload for sign-request:', payload);
        const encryptedPayload = this.encrypt(payload);
        const signRequestBody = { carrierPacket: encryptedPayload };
        const signReqUrl = `${this.secureUrl}sign-request`;

        console.log('📞 Calling sign-request API:', signReqUrl);

        try {
            // Step 1: Get signed headers
            const signResponse = await fetch(signReqUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(signRequestBody)
            });

            const signData = await signResponse.json();
            const decrypted = this.decrypt(signData.payload);

            const signedHeaders = {
                'x-client-id': decrypted.clientId,
                'x-timestamp': decrypted.timestamp,
                'x-nonce': decrypted.nonce,
                'x-signature': decrypted.signature,
            };

            console.log('🔑 Received signed headers:', signedHeaders);

            // Step 2: Use signed headers to make actual request
            const token = localStorage.getItem('user_token');
            const headers = {
                ...signedHeaders,
                'Content-Type': 'application/json',
                ...(token ? { 'Authorization': `Bearer ${token}` } : {})
            };

            console.log('🚀 Making final API call to:', url, 'with headers:', headers);

            const options = {
                method: method,
                headers: headers
            };

            if (body && method !== 'GET') {
                if (isFormData) {
                    options.body = body;
                    delete headers['Content-Type']; // Let browser set it for FormData
                } else {
                    options.body = JSON.stringify({ carrierPacket: encryptedBodyStr });
                }
            }

            const response = await fetch(url, options);
            const resp = await response.json();
            
            return this.tryDecryptResponse(resp);

        } catch (error) {
            console.error(`Signed ${method} request failed for ${url}`, error);
            throw error;
        }
    }

    tryDecryptResponse(resp) {
        if (!this.isProd) return resp;
        try {
            if (resp && typeof resp === 'object' && typeof resp.payload === 'string') {
                return this.decrypt(resp.payload);
            }
        } catch (e) {
            return resp;
        }
        return resp;
    }
}

// Create global security service instance
const securityService = new SecurityService();

// Make securityService available globally for other modules
window.securityService = securityService;

const loadingScreen = document.getElementById('loading-screen');
const loadingManager = new THREE.LoadingManager(() => {
    loadingScreen.classList.add('fade-out');
    // optional: remove loader from DOM via event listener
    loadingScreen.addEventListener('transitionend', onTransitionEnd);
});

function onTransitionEnd(event) {
    const element = event.target;
    element.remove();
}
// Draco loader
const dracoLoader = new DRACOLoader(loadingManager)
dracoLoader.setDecoderPath('draco/')

// GLTF loader
const gltfLoader = new GLTFLoader(loadingManager)
gltfLoader.setDRACOLoader(dracoLoader)

const raycaster = new THREE.Raycaster();
let objects = [];
objects.length = 0;
let isMouseOnProduct = false;
let productList;
let allVendorProductList;
let allVendor2DProductList;
let searchResult;
let current_select_sku;
let current_select_offset
let current_select_rotation
let product_config;
let storeglb_link;
let store_slug;
let current_storeno;
let storeData = []
let zoommouse = true;
let cameraHeight = 10;
let progress = 0
// Set up rotation parameters
let rotationRange = Math.PI / 1; // Total range of rotation
let rotationDuration = 500; // Duration of each rotation in milliseconds
let rotationProgress = 0; // Current rotation progress
let rotationDirection = 1; // Current rotation direction (1 = left to right, -1 = right to left)
let isAnimationPaused = false; // Flag to indicate animation pause state

// Create a clock to track elapsed time
let clock = new THREE.Clock();


// ////////////////////////////////////////////////////////////////for  localhost environment

// // Get the current URL of the page
// const urlString = window.location.href;
// // Create a URL object to parse the URL
// const url = new URL(urlString);
// // Get the search parameters from the URL
// const searchParams = new URLSearchParams(url.search);
// // Get the values of 's_slug' and 'page'
// let page = searchParams.get('s_slug');
// current_room = searchParams.get('page');

// ////////////////////////////////////////////////////////////////for  live environment


let fullurl = window.location.href;
const url = new URL(fullurl);
let pagelink = fullurl;
pagelink = pagelink.replace("http:", "");
pagelink = pagelink.replace("https:", "");
pagelink = pagelink.replace("\/\/", "");
let page_params = pagelink.split("/");
let page = page_params[1];
current_room = page_params[2]



// Check if the token is valid
async function checkToken() {
    const token = localStorage.getItem('user_token');
    if (token !== '' && token !== null && token !== undefined && token !== 'undefined') {
        try {
            const response = await securityService.signedRequest('GET', `${apibaseUrl}vendor-admin/details`);
            
            // Token is valid
            console.log('Token is valid');
            loadproducts();
        } catch (error) {
            console.error('Error:', error);
            if (localStorage.getItem('user_role') == 'admin') {
                // Token is valid for admin
                console.log('Token is valid');
                loadproducts();
            } else {
                // Token is invalid, show login popup
                $('#LoginModal').modal('show');
            }
        }
    } else {
        // No token, show login popup
        $('#LoginModal').modal('show');
    }
}

document.getElementById('loginsubmit').addEventListener('click', async function () {
    const email = document.getElementById('username').value;
    const password = document.getElementById('password').value;
    const rememberMe = document.getElementById("rememberMe").checked;
    console.log('rememberMe', rememberMe);
    console.log('email', email);
    console.log('password', password);
    if (rememberMe) {
        // Store email and password in localStorage
        localStorage.setItem("email", email);
        localStorage.setItem("password", password);
        localStorage.setItem("rememberMe", true);
    } else {
        // Clear email and password from localStorage
        localStorage.removeItem("email");
        localStorage.removeItem("password");
        localStorage.setItem("rememberMe", false);
    }

    try {
        const data = await securityService.signedRequest('POST', `${apibaseUrl}vendor-admin/login`, { email, password });
        
        if (!isEmpty(data.data)) {
            // Save token and close modal
            $('#LoginModal').modal('hide');
            localStorage.setItem('user_token', data.data.token)
            // console.log('Login successful', data.data.token);
            loadproducts();
        } else {
            // Show error message
            document.getElementById('error-message').innerText = data['message'];
        }
    } catch (error) {
        console.error('Error:', error);
        document.getElementById('error-message').innerText = 'Login failed. Please try again.';
    };
})


function isEmpty(obj) {
    for (const prop in obj) {
        if (Object.hasOwn(obj, prop)) {
            return false;
        }
    }

    return true;
}
// Run the check on page load
$(document).ready(function () {
    // Check if email and password are stored in localStorage
    if (localStorage.getItem("rememberMe") === "true") {
        document.getElementById("username").value = localStorage.getItem("email");
        document.getElementById("password").value = localStorage.getItem("password");
        document.getElementById("rememberMe").checked = true;
    }
    checkToken();
});


/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName storeProductLoad
    * @functionPurpose  for store product refresh
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


async function storeProductLoad() {
    try {
        storeData = await httpService.storeDetails(page);
        loadproducts();
    } catch (error) {
        console.error('Authentication required for store details:', error);
        // If authentication fails, show login modal
        $('#LoginModal').modal('show');
    }
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName designRoom
    * @functionPurpose  load room with ground seleted for control
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

async function designRoom() {
    try {
        // Store Deatils API call
        storeData = await httpService.storeDetails(page);
        storeglb_link = storeData.data[0].store_glb_file;   // for Local File Preview
        store_slug = storeData.data[0].store_slug;
        // loadproducts();
        let gltfStore = await gltfLoader.loadAsync(storeglb_link)
    gltfStore.scene.traverse(function (child) {
        if (child.name === "Bottom_wall" || child.name === "Floor" || child.name == "Bottom") {
            controls.ground = child;
        }
        if (child.name === "glass_door") {
            // Apply a glass shader material to the glass_door object
            const glassMaterial = new THREE.MeshStandardMaterial({
                color: 0xffffff,    // Glass color
                roughness: 0.1,     // Slightly rougher appearance
                metalness: 0.0,     // Glass is not metallic
                transparent: true,  // Enable transparency
                opacity: 0.4,       // Adjust the opacity level
                refractionRatio: 0.98,  // Refraction ratio for glass
                envMapIntensity: 1.0,   // Intensity of environment map reflection
                ior: 1.5,            // Index of Refraction for glass
                thickness: 5,
                transmission: 1,
                reflectivity: 1.0,   // Stronger reflections
                clearcoat: 1,
                clearcoatRoughness: 0.1,
                normalScale: new THREE.Vector2(0.5, 0.5),
                clearcoatNormalScale: new THREE.Vector2(0.3, 0.3),
                normalRepeat: new THREE.Vector2(2, 2)
            });
            // Assign the glass material to the "glass_door" object
            child.material = glassMaterial;
            // Check if the child has morph targets (blend shapes)
            if (child.morphTargetInfluences) {
                const doorClosedIndex = child.morphTargetDictionary["Door_open"]; // Replace with the actual name of the morph target
                if (doorClosedIndex !== undefined) {
                    // Initial value for morph target influence
                    let morphInfluence = 0.0;
                    // Define animation parameters
                    const numSteps = 225; // Number of steps for the animation
                    const stepValue = .75 / numSteps; // Increment value for each step
                    let currentStep = 0;
                    let i = .1
                    function animateMorphTarget() {

                        if (currentStep <= numSteps) {
                            // Increment the morph target influence gradually
                            morphInfluence = stepValue * currentStep;
                            child.morphTargetInfluences[doorClosedIndex] = morphInfluence;
                            camera.position.x = MathUtils.clamp(85, 59, 100);
                            camera.position.z = MathUtils.clamp(-250, 0, 10);
                            renderer.render(scene, camera);
                            if (progress == 100) {
                                // All assets are loaded, hide the loader
                                const loaderContainer = document.getElementById('loader-container');
                                loaderContainer.style.display = 'none';
                                currentStep++;
                                if (currentStep > 80) {
                                    camera.position.x = MathUtils.clamp(85, 59 - i, 100 - (i));
                                    camera.position.z = MathUtils.clamp(-250, 0, 10);
                                    renderer.render(scene, camera);
                                    i = i + .5
                                }
                                if (currentStep > 225) {
                                    animateCamera();
                                    closeDoor();
                                }
                            }
                            // Request the next animation frame
                            requestAnimationFrame(animateMorphTarget);
                        }
                    }
                    // Function to close the door
                    function closeDoor() {
                        // Reset the animation parameters
                        const numSteps = 225; // Number of steps for the animation
                        const stepValue = 3.0 / numSteps; // Decrement value for each step
                        let currentStep = 0;
                        function animateMorphTargetBack() {
                            if (currentStep <= numSteps) {
                                // Decrement the morph target influence gradually
                                const morphInfluence = 1.0 - stepValue * currentStep;
                                child.morphTargetInfluences[doorClosedIndex] = morphInfluence;
                                currentStep++;
                                // Request the next animation frame
                                requestAnimationFrame(animateMorphTargetBack);
                            }
                        }
                        // Start the closing animation
                        animateMorphTargetBack();
                    }
                    // Start the opening animation
                    animateMorphTarget();
                }
            }

        }
    })
    scene.add(gltfStore.scene)
    } catch (error) {
        console.error('Authentication required for store details:', error);
        // If authentication fails, show login modal
        $('#LoginModal').modal('show');
    }
}

let inputTimeout;

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName handleInputValue
    * @functionPurpose  Function to handle input value after 3 seconds of inactivity
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */



// Function to handle input value after 3 seconds of inactivity
function handleInputValue() {
    // Get the input value
    let inputValue = document.getElementById('searchbox').value;
    let searchkey = (inputValue).toLowerCase();
    searchResult = productList.reduce((acc, curr) => {
        let searchStr = '';
        searchStr += (curr.product_name).toLowerCase();
        // console.log(`searchStr : ${searchStr} searchkey : ${searchkey} is_found : ${searchStr.includes(searchkey)}`);
        if (searchStr.includes(searchkey)) {
            acc.push(curr);
        }
        return acc;
    }, []);

    listproductView(searchResult);
    //console.log('input text change',searchResult);
}

// Event listener for input changes
document.getElementById('searchbox').addEventListener('input', function () {
    // Clear the previous timeout
    clearTimeout(inputTimeout);

    // Set a new timeout of 3 seconds
    inputTimeout = setTimeout(handleInputValue, 2000);
});



document.getElementById('submitproductbutton').addEventListener('click', function () {
    zoommouse = true;
    // console.log('Delete Product current_storeno', current_storeno)
    // console.log('Delete Product page', page)
    // console.log('Delete Product current_select_offset', current_select_offset)
    productUpdate(current_storeno, page, '', current_select_offset);
    sceneClear();
    // designRoom();

    setTimeout(() => {
        storeProductLoad();
    }, 900);
});

document.getElementById('dismiss').addEventListener('click', function () {
    zoommouse = true;
});

document.getElementById('submitbutton').addEventListener('click', function () {
    zoommouse = true;
    if (document.querySelector('input[name="productList"]:checked')) {
        current_select_sku = document.querySelector('input[name="productList"]:checked').value;
        const foundObject = productList.find(obj => obj.product_sku === current_select_sku);
        sceneClear();
        productUpdate(current_storeno, page, current_select_sku, current_select_offset);
        placePoductOnselectRadio(foundObject);
        deleteObjectFromArrayById(productList, foundObject.product_sku)
        storeProductLoad();
    }
});

function deleteObjectFromArrayById(array, product_sku) {
    // Find the index of the object with the matching ID
    const index = array.findIndex(obj => obj.product_sku === product_sku);

    // If the object was found (index is not -1), remove it from the array
    if (index !== -1) {
        array.splice(index, 1);
    }
}

async function productUpdate(store_no, store_slug, product_sku, product_codination) {
    // update room for sku update
    let storeupdatedata = await httpService.productplace3droom(store_no, store_slug, product_sku, product_codination);
}


async function placePoductOnselectRadio(foundObject) {
    console.log('foundObject---------', foundObject);
    const searchSKU = foundObject.product_sku;
    if (foundObject) {
        let offset = new Vector3(0, 0, 0);

        let x_axis
        let y_axis
        let z_axis

        x_axis = current_select_offset[0]
        z_axis = current_select_offset[1]

        if (Math.sign(current_select_offset[2]) == 1) {
            y_axis = Math.abs(current_select_offset[2]) * -1
        }
        else {
            y_axis = Math.abs(current_select_offset[2])
        }

        offset.x = x_axis
        offset.y = y_axis
        offset.z = z_axis
        let gltfWallText = await gltfLoader.loadAsync(foundObject.product_store_3d_image[0].pro_3d_image)
        let sceneImportText = gltfWallText.scene || gltfWallText.scenes[0];
        sceneImportText.traverse(function (node) {
            if (node.isMesh) {
                node.userData = foundObject;
                node.offset = offset;
                node.storeno = current_room - 1;
                node.isProduct = true;
                objects.push(node);
            }
        })
        sceneImportText.position.add(offset);
        sceneImportText.rotation.set(current_select_rotation[0], current_select_rotation[1], current_select_rotation[2]);
        scene.add(sceneImportText)
        //Find index of specific object using findIndex method.    
        let objIndex = objectsInScene.findIndex((obj => {
            obj.uuid == sceneImportText.uuid
        }
        ));
        objectsInScene.push(sceneImportText);
    }
    setTimeout(() => {
        storeProductLoad();
    }, 800);

}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName loadproducts
    * @functionPurpose  this function use to load all store's product
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

// Create a progress bar element
const progressBar = document.getElementById('progress');
const percentageElement = document.getElementById('percentage');

// Load the 3D assets
let loadedAssets = 0;

async function loadproducts() {
    if (!storeData || !storeData.data || !storeData.data[0]) {
        console.error('No store data available, skipping loadproducts');
        return;
    }
    
    try {
        // Fetch all product lists from the current vendor
        const [allproductList, vendorallproducts] = await Promise.all([
            httpService.get3dProductList(storeData.data[0].store_owner),
            httpService.all3dProductListByVendor(storeData.data[0].store_owner)
        ]);

        allVendorProductList = vendorallproducts && vendorallproducts.data ? vendorallproducts.data.product_list : [];
        allVendor2DProductList = vendorallproducts && vendorallproducts.data ? vendorallproducts.data.product2d_list : [];
        productList = allproductList && allproductList.data ? allproductList.data.product_list : [];
        
        if (productList) {
            listproductView(productList);
        }
        
        product_config = storeData.data[0];
    if (!product_config || !product_config.store_products) {
        console.error('Store data or store_products is undefined:', product_config);
        return; // Exit if no store data available
    }
    noOfRoom = product_config.store_products.length;
    if (current_room > noOfRoom) {
        current_room = 1
        if (current_room !== null) {
            // Update the URL with the new page number
            url.searchParams.set("page", current_room);

            // Change the URL without reloading the page
            history.pushState(null, null, url.toString());
        }
    }
    let isEmpty = isEmptyStoreProduct(product_config && product_config.store_products && product_config.store_products.length > 0 ? product_config.store_products : []);
    if (noOfRoom > 1 && isEmpty || (allVendor2DProductList && allVendor2DProductList.length > 0)) {
        $('#NextButton').show();
    }
    else {
        $('#NextButton').hide();
    }

    if ((current_room == (noOfRoom))) {
        if (allVendor2DProductList && allVendor2DProductList.length > 0) {
            $('#NextButton').show();
        }
        else {
            $('#NextButton').hide();
        }
    }
    if (current_room > 1) {
        $('#BackButton').hide();
        $('#PreviousButton').show();
    }
    else {
        $('#PreviousButton').hide();
        $('#BackButton').show();
    }
    console.log('product_config.store_products[current_room - 1]', product_config);
    if (product_config.store_products.length > 0) {
        // Cache to store loaded .glb models
        const glbCache = {};

        // Loop through products
        for (let i = 0; i < product_config.store_products[current_room - 1].length; i++) {
            loadedAssets++;
            progress = (loadedAssets / (product_config.store_products[current_room - 1].length)) * 100;
            progressBar.style.width = `${progress}%`;
            percentageElement.textContent = `${Math.round(progress)}%`;

            const searchSKU = product_config.store_products[current_room - 1][i].product_sku;
            const foundObject = allVendorProductList.find(obj => obj.product_sku === searchSKU);
            let gltfWallText;

            const modelUrl = foundObject ? foundObject.product_store_3d_image[0].pro_3d_image : product_config.store_products[current_room - 1][i].product_holder_ref;

            if (modelUrl) {
                if (glbCache[modelUrl]) {
                    // Use cached model if available
                    gltfWallText = glbCache[modelUrl].clone();
                } else {
                    // Load and cache model if not available
                    try {
                        const gltf = await gltfLoader.loadAsync(modelUrl);
                        const loadedScene = gltf.scene || gltf.scenes[0];

                        if (loadedScene) {
                            glbCache[modelUrl] = loadedScene;
                            gltfWallText = loadedScene.clone();
                        } else {
                            console.error(`Scene not found in the loaded GLTF file: ${modelUrl}`);
                            continue;
                        }
                    } catch (error) {
                        console.error(`Error loading model: ${modelUrl}`, error);
                        continue;
                    }
                }

                // Apply any materials or transformations to the loaded model
                gltfWallText.traverse(function (node) {
                    if (node.isMesh) {
                        // Assign user interaction properties
                        node.userData = foundObject;
                        node.offset = product_config.store_products[current_room - 1][i].product_codination;
                        node.productRotation = product_config.store_products[current_room - 1][i].product_rotation;
                        node.storeno = current_room - 1;
                        node.isProduct = !!foundObject;
                        objects.push(node);

                        // Apply the glass shader if needed
                        if (node.name === "lense_low") {
                            const glassMaterial = new THREE.MeshStandardMaterial({
                                color: 0xffffff,
                                roughness: 0.1,
                                metalness: 0.0,
                                transparent: true,
                                opacity: 0.3,
                                refractionRatio: 0.98,
                                envMapIntensity: 1.0,
                                ior: 1,
                                thickness: 5,
                                transmission: 1,
                                reflectivity: 1.0,
                                clearcoat: 1,
                                clearcoatRoughness: 0.1,
                                normalScale: new THREE.Vector2(0.5, 0.5),
                                clearcoatNormalScale: new THREE.Vector2(0.3, 0.3),
                                normalRepeat: new THREE.Vector2(2, 2)
                            });
                            node.material = glassMaterial;
                        }
                    }
                });

                // Update position and rotation
                let offset = new THREE.Vector3(
                    product_config.store_products[current_room - 1][i].product_codination[0],
                    product_config.store_products[current_room - 1][i].product_codination[2],
                    Math.sign(product_config.store_products[current_room - 1][i].product_codination[1]) == 1 ?
                        Math.abs(product_config.store_products[current_room - 1][i].product_codination[1]) * -1 :
                        Math.abs(product_config.store_products[current_room - 1][i].product_codination[1])
                );

                gltfWallText.position.add(offset);
                gltfWallText.rotation.set(
                    product_config.store_products[current_room - 1][i].product_rotation[0],
                    product_config.store_products[current_room - 1][i].product_rotation[1],
                    product_config.store_products[current_room - 1][i].product_rotation[2]
                );
                scene.add(gltfWallText);
                objectsInScene.push(gltfWallText);
            } else {
                console.error(`Model URL not found for SKU: ${searchSKU}`);
            }
        }

    }
    else {
        progress = 100
        progressBar.style.width = `${progress}%`;
        // Update the percentage text
        percentageElement.textContent = `${Math.round(progress)}%`;
    }

    } catch (error) {
        console.error('Error loading products:', error);
        // Handle error gracefully - maybe show a message to user
    }
}

function isEmptyStoreProduct(arr) {
    if (current_room > 0 && arr.length > 0) {
        if (arr[current_room - 1].length > 0) {
            let isFalse
            for (let i = 0; i < arr[current_room - 1].length; i++) {
                if (arr[current_room - 1][i].product_sku == '') {
                    isFalse = true
                    return false;
                }
            }
            if (!isFalse) {
                return true;
            }
        }
    }
    else {
        return false;
    }

}


/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName createListItem
    * @functionPurpose  this function to create List Item
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

function createListItem(name) {
    let li = document.createElement('li');
    li.innerHTML = name;
    return li;
}

function listproductView(productList) {
    const menu = document.querySelector('#product_list');
    menu.innerHTML = '';
    for (let i = 0; i < productList.length; i++) {
        if (productList[i].product_image.length) {
            menu.appendChild(createListItem(`<input id="chkProduct${i}" type="radio" name="productList" value="${productList[i].product_sku}"/><label for="chkProduct${i}"><img src="${productList[i].product_image[0].pro_image}" alt="product"> ${productList[i].product_name}</label>`));
        }
        else {
            menu.appendChild(createListItem(`<input id="chkProduct${i}" type="radio" name="productList" value="${productList[i].product_sku}"/><label for="chkProduct${i}"> ${productList[i].product_name}</label>`));
        }
    }
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName sceneClear
    * @functionPurpose  this function use to clear store for load next store product
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function sceneClear() {
    for (let i = 0; i < objectsInScene.length; i++) {
        scene.remove(objectsInScene[i]);
        objectsInScene[i].traverse(function (object) {
            if (object instanceof THREE.Mesh) {
                scene.remove(object);
                object.geometry.dispose();
                if (Array.isArray(object.material)) {
                    object.material.forEach(function (material) {
                        material.dispose();
                    });
                } else {
                    object.material.dispose();
                }
            }
        });
    }
    objectsInScene.length = 0; // Clear the array
    objects.length = 0;
}

// Initialise Main Usefull functioon
designRoom();
init();
animate();


// back button click to vendor home page website
document.getElementById('BackButton').onclick = function () {
    window.open(`${baseUrl}/vendor/${store_slug}`, '_self');
}

// next button click to enter next store 
document.getElementById('NextButton').onclick = function () {
    if ((current_room == (noOfRoom)) && allVendor2DProductList.length > 0) {
        window.open(`${baseUrl}/2d-products/${store_slug}/${current_room}`, '_self');
    }
    current_room = current_room + 1
    if (current_room !== null) {
        // Increase the page number
        const newPage = parseInt(current_room) + 1;

        // Update the URL with the new page number
        url.searchParams.set("page", newPage);

        // Change the URL without reloading the page
        history.pushState(null, null, url.toString());
    }
    sceneClear();
    storeProductLoad();
}
// previous button click to enter previous store 
document.getElementById('PreviousButton').onclick = function () {
    current_room = current_room - 1
    const currentURL = window.location.href;
    const url = new URL(currentURL);

    // Get the current page parameter
    if (current_room !== null) {
        // Increase the page number
        const newPage = parseInt(current_room) - 1;

        // Update the URL with the new page number
        url.searchParams.set("page", newPage);

        // Change the URL without reloading the page
        history.pushState(null, null, url.toString());
    }
    sceneClear();
    storeProductLoad();
}

document.getElementById('uparrow').onclick = function () {
    if (cameraHeight < 20)
        cameraHeight += 1
    camera.position.y = cameraHeight
}

document.getElementById('downarrow').onclick = function () {
    if (cameraHeight > 5)
        cameraHeight -= 1
    camera.position.y = cameraHeight
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName init
    * @functionPurpose  this function use to initilize three.js functionality
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

function init() {
    camera = new THREE.PerspectiveCamera(80, window.innerWidth / window.innerHeight, 1, 200);
    camera.position.y = cameraHeight;
    camera.rotation.set(0, Math.PI / 2, 0);
    scene = new THREE.Scene();
    scene.background = new THREE.Color('grey');

    const light = new THREE.HemisphereLight(0xeeeeff, 0x777788, 2);
    light.position.set(0.5, 1, 0.75);
    scene.add(light);

    const directionalLight = new THREE.DirectionalLight('0xfffafa', 0.5);
    directionalLight.position.set(0, 1.1, 0)
    scene.add(directionalLight);

    document.addEventListener('mousedown', onMouseDown);
    document.addEventListener('mouseup', onMouseUp);
    document.addEventListener('touchend', onTouchEnd, true);
    document.addEventListener('mousemove', onMouseMove, false)
    document.addEventListener('touchend', onTouchEnd2, true)
    document.addEventListener('touchmove', onTouchMove, true)
    // Add a touchstart event listener to track the initial distance between two touches
    document.addEventListener('touchstart', onTouchStart);
    document.addEventListener('wheel', onDocumentMouseWheel);
    renderer = new THREE.WebGLRenderer({ antialias: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    renderer.outputEncoding = THREE.sRGBEncoding
    renderer.toneMapping = THREE.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 0.85;
    renderer.setSize(window.innerWidth, window.innerHeight);
    document.body.appendChild(renderer.domElement);

    controls = new IndoorControls(camera, renderer.domElement);
    let helperMaterial = new THREE.MeshBasicMaterial();
    helperMaterial.transparent = false;
    helperMaterial.opacity = 0.5;
    mouseHelper = new THREE.Mesh(new THREE.CircleBufferGeometry(0.7, 32), helperMaterial);

    viewport = document.getElementById('viewport');
    viewport.appendChild(renderer.domElement);
    controls.addEventListener('move', function (event) {
        scene.add(mouseHelper);
        let intersect = event.intersect;
        mouseHelper.position.set(0, 0, 0);
        mouseHelper.lookAt(new Vector3(0, 50, 0))
        mouseHelper.position.copy(new Vector3(intersect.point.x, intersect.point.y + .37, intersect.point.z));
        mouseHelper.position.addScaledVector(intersect.face.normal, 0.001);

    });
    viewport.ondragover = function (event) {
        event.preventDefault();
    };
    viewport.ondrop = function (event) {
        event.preventDefault();
    };
    window.addEventListener('resize', onWindowResize);
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onWindowResize
    * @functionPurpose  this function use to onWindowResize
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */



function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onDocumentMouseWheel
    * @functionPurpose  this function use to onDocumentMouseWheel
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function onDocumentMouseWheel(event) {
    if (zoommouse) {
        const fov = camera.fov + event.deltaY * 0.05;
        camera.fov = THREE.MathUtils.clamp(fov, 10, 75);
        camera.updateProjectionMatrix();
    }
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onTouchMove
    * @functionPurpose  this function use to onTouchMove
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

let initialDistance = 0;
let zoomFactor = 1.0;

// Adjust this zoom speed factor to control the zoom speed
const zoomSpeed = 0.01; // You can experiment with different values
const zoomSmoothingFactor = 0.2; // Adjust the smoothing factor

function onTouchStart(event) {
    if (event.touches.length === 2) {
        // Calculate the initial distance between the two touches
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        initialDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);
    }
}

function onTouchMove(event) {
    if (event.touches.length === 2) {
        // Calculate the new distance between the two touches
        const touch1 = event.touches[0];
        const touch2 = event.touches[1];
        const newDistance = Math.hypot(touch2.clientX - touch1.clientX, touch2.clientY - touch1.clientY);

        // Calculate the zoom factor based on the change in distance
        const zoomDelta = newDistance / initialDistance;

        // Apply smoothing to zoomDelta
        zoomFactor = zoomFactor * (1 - zoomSmoothingFactor) + zoomDelta * zoomSmoothingFactor;

        // Apply the zoom factor to your 3D camera's field of view
        const newFov = camera.fov / zoomFactor;

        // Slow down the zoom speed by multiplying with the zoomSpeed factor
        const adjustedFov = camera.fov + (newFov - camera.fov) * zoomSpeed;

        camera.fov = THREE.MathUtils.clamp(adjustedFov, 10, 75);

        // Update the camera's projection matrix
        camera.updateProjectionMatrix();
    }
}

//////////////////////////////////////


function onMouseUp(event) {
    // console.log("============= ON MOUSE UP =================");
    // console.log(event);

    const mouse = {
        x: (event.clientX / renderer.domElement.clientWidth) * 2 - 1,
        y: -(event.clientY / renderer.domElement.clientHeight) * 2 + 1
    }
    if (isMouseOnProduct) {
        // console.log("!!!!!!!!!!!!!!!  ON PRODUCT CLICK !!!!!!!!!!!!!!!!!");
        // console.log(productData);
        raycaster.setFromCamera(mouse, camera);

        const intersects = raycaster.intersectObjects(objects, false)
        // console.log("^^^^^^^^^^^^^^^^^^^^^^^");
        console.log('On onMouseUp intersects', intersects);

        current_select_offset = intersects[0].object.offset;
        current_select_rotation = intersects[0].object.productRotation;
        current_storeno = intersects[0].object.storeno
        //console.log('All Objects on particullar Products  ========> ', intersects[0].object.offset)
        //console.log('All Objects on particullar Products  ========> ', intersects[0].object.userData)
        if (intersects.length > 0) {
            // console.log('All Objects on particullar Products  ========> ', intersects[0].object)
            let product = intersects[0].object.userData;
            if (product == undefined) {
                // console.log('Clicked on Un Product Place')
                $('#basicModal').modal('toggle');
                zoommouse = false;
            }
            else {
                // console.log('Clicked on Product Place')
                if (product.hasOwnProperty('product_slug')) {
                    $('#changepeoductModal').modal('toggle');
                    zoommouse = false;
                }
            }
        }


    }
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onTouchEnd
    * @functionPurpose  this function use to onTouchEnd
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

// Define a function to handle touchend events
function onTouchEnd(event) {
    if (event.touches.length !== 2) {
        isZooming = false;
    }
    // Your code to handle touchend events goes here
    // This code replicates your existing onMouseUp function
    const touch = event.changedTouches[0]; // Get the first touch point
    // Calculate the touch coordinates relative to the renderer
    const touchX = (touch.clientX / renderer.domElement.clientWidth) * 2 - 1;
    const touchY = -(touch.clientY / renderer.domElement.clientHeight) * 2 + 1;

    const mouse = {
        x: touchX,
        y: touchY
    };

    if (isMouseOnProduct) {
        raycaster.setFromCamera(mouse, camera);

        const intersects = raycaster.intersectObjects(objects, false);

        current_select_offset = intersects[0].object.offset;
        current_select_rotation = intersects[0].object.productRotation;
        current_storeno = intersects[0].object.storeno;

        if (intersects.length > 0) {
            let product = intersects[0].object.userData;
            if (product == undefined) {
                // console.log('Touched on Un Product Place');
                $('#basicModal').modal('toggle');
                zoommouse = false;
            } else {
                //console.log('Touched on Product Place');
                if (product.hasOwnProperty('product_slug')) {
                    $('#changepeoductModal').modal('toggle');
                    zoommouse = false;
                }
            }
        }
    }
}
/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onMouseDown
    * @functionPurpose  this function use to onMouseDown
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function onMouseDown(event) {
    // const mouse = {
    //     x: (event.clientX / renderer.domElement.clientWidth) * 2 - 1,
    //     y: -(event.clientY / renderer.domElement.clientHeight) * 2 + 1
    // }
    // // console.log("Mouse Down Called")
    // raycaster.setFromCamera(mouse, camera);

    // const intersects = raycaster.intersectObjects(objects, false)
    // if (intersects.length > 0) {

    //     for (let i in objects) {
    //         if (objects[i] == intersects[0].object) {
    //             console.log("Object Number is " + i); // {a: 5, b: 6}
    //         }
    //     }
    // }

}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onMouseMove
    * @functionPurpose  this function use to onMouseMove
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

function onMouseMove(event) {

    const mouse = {
        x: (event.clientX / renderer.domElement.clientWidth) * 2 - 1,
        y: -(event.clientY / renderer.domElement.clientHeight) * 2 + 1
    }
    raycaster.setFromCamera(mouse, camera);
    const intersects = raycaster.intersectObjects(objects, false)
    if (intersects.length > 0) {
        controls.enabled = false;
        isMouseOnProduct = true;
        document.body.style.cursor = 'pointer'
    } else {
        document.body.style.cursor = 'default'
        controls.enabled = true;
        isMouseOnProduct = false;
    }
}


/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName onTouchEnd2
    * @functionPurpose  this function use to onTouchEnd2
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */


function onTouchEnd2(event) {
    // Your code to handle touchend events goes here
    // This code replicates your existing onMouseUp function
    const touch = event.changedTouches[0]; // Get the first touch point
    // Calculate the touch coordinates relative to the renderer
    const touchX = (touch.clientX / renderer.domElement.clientWidth) * 2 - 1;
    const touchY = -(touch.clientY / renderer.domElement.clientHeight) * 2 + 1;

    const mouse = {
        x: touchX,
        y: touchY
    };


    raycaster.setFromCamera(mouse, camera);

    const intersects = raycaster.intersectObjects(objects, false)
    if (intersects.length > 0) {
        controls.enabled = false;
        isMouseOnProduct = true;
        document.body.style.cursor = 'pointer'
    } else {
        document.body.style.cursor = 'default'
        controls.enabled = true;
        isMouseOnProduct = false;
    }
}

/**
    * @author Munnaf Hossain Mondal
    * @Date_Created  
    * @Date_Modified  
    * @function async
    * @functionName animate
    * @functionPurpose  this function use to animate whole project. this will run all time any changes
    *                                                   
    * @functionParam 
    *
    * @functionSuccess
    *
    * @functionError 
    */

function animate() {
    requestAnimationFrame(animate);
    controls.update();
    camera.position.x = MathUtils.clamp(camera.position.x, -33, 33);
    camera.position.z = MathUtils.clamp(camera.position.z, -42, 42);
    renderer.render(scene, camera);
}

function animateCamera() {
    if (!isAnimationPaused) {
        // Calculate the rotation progress based on the elapsed time and duration
        rotationProgress += rotationDirection * (1 / rotationDuration) * (Math.PI / 120) * (clock.getDelta() * 1000);
        // Apply easing function to the rotation progress
        let easedProgress = easeInOutSine(rotationProgress);
        // Calculate the rotation angle based on the eased progress and rotation range
        let rotationAngle = easedProgress * rotationRange;
        // Update the camera rotation around the Y-axis
        camera.rotation.y = rotationAngle;
        // Check if the rotation reaches the end of the range
        if (rotationProgress >= 1) {
            zoomIn();
            if (zoomedInOnce) {
                rotationDirection = -1; // Reverse the rotation direction
            }

        } else if (rotationProgress <= 0) {
            rotationDirection = 1; // Reverse the rotation direction
        }
        /////////////////// this code for first 180 animation after focus boys section ////////////////////////

        // if (rotationDirection == -1 && rotationProgress <= .70) {
        //     isAnimationPaused = true;
        //     camera.position.x=-25.57286190947398;
        //     camera.position.y= 10;
        //     camera.position.z= 38.02548455945675;
        //     renderer.render(scene, camera);
        // }
    }

    // Request the next frame of the animation
    requestAnimationFrame(animateCamera);
}

// Easing function for smooth in-out motion (sine function)
function easeInOutSine(t) {
    return (1 - Math.cos(Math.PI * t)) / 2;
}

// Event listener for mouseover
function onMouseOver() {
    isAnimationPaused = true;
    // zoomOut();
}

// Event listener for mouseout
function onMouseOut() {
    isAnimationPaused = true;
    // zoomOut();
}

// Event listener for mouseover
function onTouchStarts() {
    isAnimationPaused = true;
    // zoomOut();
}

// Event listener for mouseout
function onTouchEnds() {
    isAnimationPaused = true;
    // zoomOut();
}

// Add event listeners to the renderer element
renderer.domElement.addEventListener('mouseover', onMouseOver, false);
renderer.domElement.addEventListener('mouseout', onMouseOut, false);
renderer.domElement.addEventListener('touchstart', onTouchStarts, false);
renderer.domElement.addEventListener('touchend', onTouchEnds, false);


/////////////////////////////// Camera Zoom ///////////////////////////////////////

// Camera zoom variables
let zoomLevel = 1;
const minZoom = 1;
const maxZoom = 3;
const zoomIncrement = .01;
// Camera auto zoom and stop variables
const targetPosition = new THREE.Vector3(0, 0, 0); // Adjust the target position as needed
const stopDistance = 5; // Adjust the distance at which to stop zooming
let zoomingIn = true; // Indicates whether we are currently zooming in or out
let zoomedInOnce = false;
let zoomedOutOnce = false;

// Auto zoom on start


// Update camera zoom
function updateCameraZoom() {
    // Adjust camera properties based on zoom level
    const newFOV = 75 / zoomLevel;
    camera.fov = newFOV;
    camera.updateProjectionMatrix();
}

// Camera zoom functions
function zoomIn() {
    if (!zoomedInOnce) {
        zoomLevel += zoomIncrement;
        zoomLevel = Math.min(zoomLevel, maxZoom);
        updateCameraZoom();

        // Check if we should start zooming out
        if (zoomLevel >= maxZoom) {
            zoomedInOnce = true;
        } else {
            requestAnimationFrame(zoomIn);
        }
    }
}

function zoomOut() {
    if (!zoomedOutOnce) {
        zoomLevel -= zoomIncrement;
        zoomLevel = Math.max(zoomLevel, minZoom);
        updateCameraZoom();

        // Check if we should stop zooming out
        if (zoomLevel <= minZoom) {
            zoomedOutOnce = true;
        } else {
            requestAnimationFrame(zoomOut);
        }
    }
}
